import { motion } from "framer-motion";
import { ShieldCheck, Handshake, Clock } from "lucide-react";

const CRAFT_IMG =
  "https://images.unsplash.com/photo-1543309959-4d45288d1629?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHx0cmltbWluZyUyMGhlZGdlJTIwZ2FyZGVuZXJ8ZW58MHx8fHwxNzkzMzc3Njc2fDA&ixlib=rb-4.1.0&q=85";

const VALUES = [
  { icon: ShieldCheck, title: "Qualitätsversprechen", text: "Wir arbeiten so, als wäre es unser eigener Garten – präzise und mit hochwertigen Materialien." },
  { icon: Handshake, title: "Persönlich & direkt", text: "Sie sprechen immer direkt mit dem Inhaber. Keine Umwege, keine anonymen Hotlines." },
  { icon: Clock, title: "Zuverlässig & pünktlich", text: "Vereinbarte Termine halten wir ein – von der Besichtigung bis zur Übergabe." },
];

export default function About() {
  return (
    <section id="ueber-uns" className="py-16 sm:py-24 lg:py-32 px-4 sm:px-8 lg:px-16 bg-[#F1EFEA]" data-testid="about-section">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative rounded-2xl overflow-hidden h-80 sm:h-[28rem]"
        >
          <img src={CRAFT_IMG} alt="Handwerkliche Arbeit im Gartenbau" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute bottom-4 left-4 bg-white rounded-xl px-4 py-3 shadow-xl shadow-black/20" data-testid="about-logo-card">
            <img src="/logo.jpg" alt="LLP Zaun&Garten Logo" className="h-12 sm:h-14 w-auto" />
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#244A32]">Über uns</p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mt-4">
            Handwerk mit Handschrift – LLP Zaun&Garten
          </h2>
          <p className="mt-4 text-base text-[#575953] leading-relaxed">
            Hinter LLP Zaun&Garten steht Inhaber Anatoli Zygankow. Von unserem Standort in Minden
            betreuen wir Privat- und Geschäftskunden in der ganzen Region – vom einzelnen Zaunelement
            bis zum komplett neu gestalteten Außenbereich.
          </p>
          <div className="mt-8 space-y-6">
            {VALUES.map(({ icon: Icon, title, text }, i) => (
              <motion.div
                key={title}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.12 }}
                className="flex gap-4"
              >
                <div className="w-11 h-11 rounded-xl bg-[#244A32]/10 flex items-center justify-center shrink-0">
                  <Icon className="w-5 h-5 text-[#244A32]" />
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-base">{title}</h3>
                  <p className="text-sm text-[#575953] mt-1 leading-relaxed">{text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
